(function ($) {
	"use strict";

	// background image
	$("[data-bg-image]").each(function () {
		var $this = $(this),
			$image = $this.data("bg-image");
		$this.css("background-image", "url(" + $image + ")");
	});

	// Header Sticky  Js
	$(window).on("scroll", function () {
		var scroll = $(window).scrollTop();
		if (scroll < 100) {
			$("#header-sticky").removeClass("header-sticky");
		} else {
			$("#header-sticky").addClass("header-sticky");
		}
	});

	// Mobile Menu
	$("#main-menu").meanmenu({
		meanMenuContainer: "#mobile-navbar-menu",
		meanScreenWidth: "991",
		meanExpand: ["<i class='fa fa-plus'></i>"],
	});

	// Mobile Menu Overlay
	var canva_expander = $(".canva_expander");
	if (canva_expander.length) {
		$(".canva_expander, #canva_close, #tj-overlay-bg2").on("click", function (e) {
			e.preventDefault();
			$("body").toggleClass("canvas_expanded");
		});
	}

	// Menu href=# link bihaviour - desktop
	$("#main-menu a").on('click', function (e) {
		if ('#' === $(this).attr('href')) {
			e.preventDefault();
		}
	});

	// Menu href=# link bihaviour - mobile
	$("#menu-main-menu a:not(.mean-expand)").on('click', function (e) {
		let $this_a = $(this);

		if ('#' === $this_a.attr('href')) {
			e.preventDefault();
			console.log();
			try {
				let $expandBtn = $this_a.closest('li').find('a.mean-expand');

				if ($expandBtn.hasClass("mean-clicked")) {
					$expandBtn.prev("ul").slideUp(300, function () {
					});
					$expandBtn.parent().removeClass("dropdown-opened");
				} else {
					$expandBtn.prev("ul").slideDown(300, function () {
					});
					$expandBtn.parent().addClass("dropdown-opened");
				}
				$expandBtn.toggleClass("mean-clicked");
			} catch (ex) {
				console.error(ex);
			}

		}
	});

	// Testimonial Slider One
	if (window.Swiper && $(".tj-testimonial-slider").length) {
		var testimonial1 = new Swiper(".tj-testimonial-slider", {
			slidesPerView: 2,
			spaceBetween: 30,
			autoplay: {
				delay: 8500,
			},
			loop: true,
			breakpoints: {
				320: {
					slidesPerView: 1,
				},
				640: {
					slidesPerView: 1,
				},
				991: {
					slidesPerView: 2,
				},
				768: {
					slidesPerView: 1,
				},
				1024: {
					slidesPerView: 2,
				},
			},
		});
	}

	// Project slider
	$(".tj-project-slider").owlCarousel({
		items: 1,
		nav: false,
		thumbs: false,
		loop: true,
		center: false,
		//margin: 100,
		autoplayTimeout: 5000,
		autoplay: true,
		dots: false,
		//autoWidth:true,
		responsive: {
			0: {
				items: 1,
			},
			480: {
				items: 1,
			},
			576: {
				items: 2,
			},
			767: {
				items: 2,
			},
			1080: {
				items: 3,
			},
			1200: {
				items: 3,
			},
			1500: {
				items: 3,
			},
		},
	});

	// Nice Select
	$("select").niceSelect();

	// Sal Animation
	if (window.matchMedia) {
		const notMobileMediaQuery = window.matchMedia("(min-width: 768px)");
		if (notMobileMediaQuery.matches) {
			sal({
				threshold: 0.1,
				once: true,
			});
		} else {
			sal({threshold: 0.0, disable: true}).disable();
		}
	}


	/*-- logiland scroll top scripts start --*/
	var logilandScrollTop = document.querySelector(".logiland-scroll-top");
	if (logilandScrollTop != null) {
		var scrollProgressPatch = document.querySelector(".logiland-scroll-top path");
		var pathLength = scrollProgressPatch.getTotalLength();
		var offset = 50;
		scrollProgressPatch.style.transition = scrollProgressPatch.style.WebkitTransition = "none";
		scrollProgressPatch.style.strokeDasharray = pathLength + " " + pathLength;
		scrollProgressPatch.style.strokeDashoffset = pathLength;
		scrollProgressPatch.getBoundingClientRect();
		scrollProgressPatch.style.transition = scrollProgressPatch.style.WebkitTransition =
			"stroke-dashoffset 10ms linear";
		window.addEventListener("scroll", function (event) {
			var scroll = document.body.scrollTop || document.documentElement.scrollTop;
			var height = document.documentElement.scrollHeight - document.documentElement.clientHeight;
			var progress = pathLength - (scroll * pathLength) / height;
			scrollProgressPatch.style.strokeDashoffset = progress;
			var scrollElementPos = document.body.scrollTop || document.documentElement.scrollTop;
			if (scrollElementPos >= offset) {
				logilandScrollTop.classList.add("progress-done");
			} else {
				logilandScrollTop.classList.remove("progress-done");
			}
		});
		logilandScrollTop.addEventListener("click", function (e) {
			e.preventDefault();
			window.scroll({
				top: 0,
				left: 0,
				behavior: "smooth",
			});
		});
	}
	/*-- logiland scroll top scripts end --*/
})(jQuery);
